import PropTypes from 'prop-types';

import { ReactComponent as AngleUpIcon } from 'assets/angle-up.svg';

const InspirationCarouselHeader = ({
  activeIndex,
  totalCount,
  onPrev,
  onNext,
  children,
}) => (
  <div className="flex justify-between items-center gap-2">
    <div className="flex items-center gap-2 w-full justify-between">
      <p className="font-medium text-[11px] text-black/50 leading-4 m-0">
        Inspiration
      </p>
      {totalCount > 1 && (
        <div className="flex items-center gap-1">
          <button
            type="button"
            className="flex items-center justify-center w-5 h-5 rounded
              text-black/50 hover:text-black/80 disabled:opacity-30 disabled:cursor-not-allowed
              transition-colors cursor-pointer"
            onClick={onPrev}
            disabled={activeIndex === 0}
            aria-label="Previous inspiration"
          >
            <AngleUpIcon className="-rotate-90 w-3 h-3" />
          </button>
          <span className="text-[11px] text-black/50 tabular-nums select-none">
            {activeIndex + 1}
            {' / '}
            {totalCount}
          </span>
          <button
            type="button"
            className="flex items-center justify-center w-5 h-5 rounded
              text-black/50 hover:text-black/80 disabled:opacity-30 disabled:cursor-not-allowed
              transition-colors cursor-pointer"
            onClick={onNext}
            disabled={activeIndex === totalCount - 1}
            aria-label="Next inspiration"
          >
            <AngleUpIcon className="rotate-90 w-3 h-3" />
          </button>
        </div>
      )}
    </div>
    {children}
  </div>
);

InspirationCarouselHeader.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  children: PropTypes.node,
};

InspirationCarouselHeader.defaultProps = {
  children: null,
};

export default InspirationCarouselHeader;
